import React from "react";
import { useTranslation } from "react-i18next";

type UserManagementFooterProps = {
  selectedCount: number;
  handleInviteUsers: () => void;
  setShowInvitationModal: (show: boolean) => void;
};

export const UserManagementFooter = ({
  selectedCount,
  handleInviteUsers,
  setShowInvitationModal,
}: UserManagementFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className="info-table__footer" data-testid="user-invitation-footer">
      <div className="global-utilities__container">
        <div className="info-table__footer-left">
          <span className="invite-title">
            {t("userManagementPage.sendInvitation_title", {
              count: selectedCount,
            })}
          </span>
          <span className="invite-text" data-testid="invitations-count">
            {t("userManagementPage.sendInvitation_subtitle", {
              count: selectedCount,
            })}
          </span>
        </div>
        <div className="info-table__footer-right">
          <button
            className="DNA-button"
            data-testid="btn-send-invitation"
            onClick={() => {
              handleInviteUsers();
              setShowInvitationModal(true);
            }}
          >
            {t("userManagementPage.sendInvitation_btn", {
              count: selectedCount,
            })}
            <i className="icon icon-send" />
          </button>
        </div>
      </div>
    </div>
  );
};
